<template>
  <div class="air__utils__scrollTable mb-4">
    <a-table
      :rowKey="record => record.section"
      :columns="columns"
      :dataSource="data"
      :pagination="false"
      :scroll="{ x: 'max-content' }"
      :loading="loading"
    >
      <!-- Progress Bar -->
      <template slot="progress" slot-scope="progress">
        <a-progress
          :percent="progress || 0"
          :strokeColor="getProgressColor(progress)"
          size="small"
          :status="progress === 100 ? 'success' : 'active'"
          :format="() => `${progress || 0}%`"
        />
      </template>

      <!-- Status Breakdown -->
      <template slot="status_breakdown" slot-scope="breakdown">
        <div v-if="breakdown" class="d-flex flex-wrap justify-content-center" style="gap: 4px;">
          <a-tag color="green">Done: {{ breakdown.completed || 0 }}</a-tag>
          <a-tag color="blue">In Prog: {{ breakdown.in_progress || 0 }}</a-tag>
          <a-tag color="orange">Start: {{ breakdown.started || 0 }}</a-tag>
          <a-tag color="#595959" style="color: #fff;">Pending: {{ breakdown.not_started || 0 }}</a-tag>
        </div>
        <span v-else>N/A</span>
      </template>

      <!-- Actions -->
      <template slot="actions" slot-scope="text, record">
        <a-button type="primary" @click="$emit('viewProgress', record)">
          View Progress
        </a-button>
      </template>
    </a-table>
  </div>
</template>

<script>
const columns = [
  {
    title: 'Section',
    dataIndex: 'section',
    key: 'section',
    width: 130,
    sorter: true,
    className: 'text-left',
  },
  {
    title: 'Progress',
    dataIndex: 'progress',
    key: 'progress',
    width: 160,
    scopedSlots: { customRender: 'progress' },
    sorter: true,
    className: 'text-center',
  },
  {
    title: 'Topics Completed',
    dataIndex: 'topics_completed',
    key: 'topics_completed',
    width: 140,
    className: 'text-center',
  },
  {
    title: 'Subtopics Completed',
    dataIndex: 'sub_topics_completed',
    key: 'sub_topics_completed',
    width: 140,
    className: 'text-center',
  },
  {
    title: 'Status Breakdown',
    dataIndex: 'status_breakdown',
    key: 'status_breakdown',
    width: 280,
    scopedSlots: { customRender: 'status_breakdown' },
    className: 'text-center',
  },
  {
    title: 'Actions',
    dataIndex: 'actions',
    key: 'actions',
    width: 130,
    scopedSlots: { customRender: 'actions' },
    className: 'text-center',
  },
]

export default {
  name: 'ProgressBySectionTable',
  props: {
    loading: Boolean,
    data: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      columns,
    }
  },
  methods: {
    getProgressColor(progress) {
      if (progress < 30) return '#ff4d4f' // red
      if (progress < 70) return '#faad14' // orange
      return '#52c41a' // green
    },
    getStatusColor(status) {
      if (status === 'On Track') return 'green'
      if (status === 'In Progress') return 'orange'
      if (status === 'Lagging') return 'red'
      return 'default'
    },
  },
}
</script>

<style scoped>
.font-weight-bold {
  font-weight: 600;
}
.text-danger {
  color: #ff4d4f;
}
</style>
